import * as moment from "moment";
import { JwtToken } from "./jwt.type";

export function parseJwt(token: string): JwtToken {
  try {
    const base64Url = token.split(".")[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split("")
        .map(function (c) {
          return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join(""),
    );
    const userInfo = JSON.parse(jsonPayload);
    const expDate = userInfo.exp * 1000;
    const today = moment();
    const exp = moment(new Date(expDate));
    const duration = moment.duration(exp.diff(today));
    const secondsRemaining = duration.asSeconds();
    userInfo.secondsRemaining = secondsRemaining;

    if (userInfo && Date.now() >= userInfo.exp * 1000) {
      const errorMessage = { code: 403, message: "Expired Token" };
      throw errorMessage;
    }
    return userInfo;
  } catch (ex) {
    const { message, code } = ex;
    const errorMessage = { code: code || "invalid_token", message: message || "Invalid Token" };
    throw errorMessage;
  }
}
